export const SHOW_ALERT = 'show_alert'
export const HIDE_ALERT = 'hide_alert'
export const HEADER_MODE = 'header_mode'
export const SHOW_TOOLBAR = 'show_toolbar'
export const HIDE_TOOLBAR = 'hide_toolbar'
export const SHOW_POPOVER = 'show_popover'
export const HIDE_POPOVER = 'hide_popover'
export const SET_UPLOADER_ACTIVE = 'set_uploader_active'
export const SHOW_TOASTER = 'show_toaster'
export const HIDE_TOASTER = 'hide_toaster'
export const SET_CAN_RENDER = 'set_can_render'
export const SHOW_CONTEXT_MENU = 'show_context_menu'
export const HIDE_CONTEXT_MENU = 'hide_context_menu'
export const FORCE_UPDATE = 'force_update'
export const TOGGLE_SAVING = 'toggle_saving'
export const TOGGLE_SIDEBAR = 'toggle_sidebar'
export const TOGGLE_PAGE_ORDER = 'toggle_page_order'
export const SHOW_FILE_MANAGER = 'show_file_manager'
export const LOCK_BACKGROUND = 'lock_background'
export const SET_ZOOM = 'set_zoom'
export const SET_ZOOMABLE_INSTANCE = 'set_zoomable_instance'



// WEBPACK FOOTER //
// ./src/store/types/ui.js